import axios from 'api/axios'
import { store } from './store'

export const getCoreUrl = () => {
  const state = store.getState()
  if (state.clientid) return state.clientid
  const clients = state.clients || []
  const currentClient = clients.find((f) => f.name === state.servername && f.id)
  return currentClient.id
}

export const get = async (url) => {
  const usedurl = url.indexOf('http') >= 0 ? url : getCoreUrl() + url
  const response = await axios.get(usedurl)
  return response?.data
}

export const post = async (url, body) => {
  const usedurl = url.indexOf('http') >= 0 ? url : getCoreUrl() + url

  const response = await axios.post(usedurl, body)

  return response?.data
}

export const put = async (url, body) => {
  const usedurl = url.indexOf('http') >= 0 ? url : getCoreUrl() + url

  const response = await axios.put(usedurl, body)
  return response?.data
}

export const del = async (url) => {
  const usedurl = url.indexOf('http') >= 0 ? url : getCoreUrl() + url

  const response = await axios.delete(usedurl)
  return response?.data
}
